var quizQuestions = [
    {
        question: "Consideras poseer alguna de las siguientes capacidades",
        answers: [
            {
                type: "Informática",
                content: "Diseño de estrategias y organización"
            },
            {
                type: "Administración",
                content: "Coordinación y emprendimiento"
            },
            {
                type: "Contaduría",
                content: "Gestión y control"
            },
            {
                type: "Mercadotecnia",
                content: "Innovar y crear"
            },
            {
                type: "Derecho",
                content: "Mediador y analítico "
            },
            {
                type: "Educación",
                content: "Guiar y compartir"
            },
            {
                type: "Proyectos",
                content: "Investigar e implementar"
            },
            {
                type: "Turismo",
                content: "Planificar y aprender idiomas distintos"
            },
        ]
    },
    {
        question: "Siento satisfacción cuando soy capaz de…",
        answers: [
            {
                type: "Informática",
                content: "Aprender cosas nuevas en el uso de las tecnologías "
            },
            {
                type: "Administración",
                content: "Elaborar un plan para el rendimiento de mi dinero"
            },
            {
                type: "Contaduría",
                content: "Sintetizar información y organizar números"
            },
            {
                type: "Mercadotecnia",
                content: "Construir relaciones interpersonales"
            },
            {
                type: "Derecho",
                content: "Concluir con un problema"
            },
            {
                type: "Educación",
                content: "Ejecutar actividades que me dejen un nuevo aprendizaje"
            },
            {
                type: "Proyectos",
                content: "Emplear alguna tarea relacionada con el medio ambiente"
            },
            {
                type: "Turismo",
                content: "Aprender cosas nuevas sobre otras culturas"
            },
        ]
    },
    {
        question: "Disfruto pasar mi tiempo haciendo actividades como:",
        answers: [
            {
                type: "Informática",
                content: "Estar utilizando una computadora la mayor parte del tiempo"
            },
            {
                type: "Administración",
                content: "Organizar un grupo de trabajo para echar andar algo"
            },
            {
                type: "Contaduría",
                content: "Asesorar a otros"
            },
            {
                type: "Mercadotecnia",
                content: "Crear diseños"
            },
            {
                type: "Derecho",
                content: "Leer"
            },
            {
                type: "Educación",
                content: "Manualidades"
            },
            {
                type: "Proyectos",
                content: "Planes y proyectos relacionados con el medio natural"
            },
            {
                type: "Turismo",
                content: "Organizar salidas o viajes"
            },
        ]
    },
    {
        question: "¿Cuál de las siguientes opciones que se acercaría a uno de tus objetivos profesionalmente?",
        answers: [
            {
                type: "Informática",
                content: "Desarrollar y crear un programa funcional mediante el uso de las tecnologías"
            },
            {
                type: "Administración",
                content: "Crear mi propia empresa"
            },
            {
                type: "Contaduría",
                content: "Tener mi despacho contable"
            },
            {
                type: "Mercadotecnia",
                content: "Impulsar grandes marcas y colaborar con las mismas"
            },
            {
                type: "Derecho",
                content: "Tener mi propio bufete de abogados"
            },
            {
                type: "Educación",
                content: "Desarrollar una curricula educativa, para poder crear mi propia escuela"
            },
            {
                type: "Proyectos",
                content: "Crear un proyecto de gran impacto para el beneficio del medio ambiente"
            },
            {
                type: "Turismo",
                content: "Hablar más de 3 idiomas y conocer otros países "
            },
        ]
    },
    {
        question: "Tengo conocimientos sobre…",
        answers: [
            {
                type: "Informática",
                content: "Programas básicos de microsoft office"
            },
            {
                type: "Administración",
                content: "Codificación y estructura"
            },
            {
                type: "Contaduría",
                content: "Finanzas"
            },
            {
                type: "Mercadotecnia",
                content: "Las relaciones públicas"
            },
            {
                type: "Derecho",
                content: "Temas jurídicos"
            },
            {
                type: "Educación",
                content: "El acompañamiento y asesoramiento a terceros"
            },
            {
                type: "Proyectos",
                content: "Los ecosistemas"
            },
            {
                type: "Turismo",
                content: "Más de una cultura"
            },
        ]
    },
    {
        question: "¿Cuál de las siguientes materias te interesaban más en la escuela?",
        answers: [
            {
                type: "Informática",
                content: "Computación y electrónica"
            },
            {
                type: "Administración",
                content: "Matemáticas y Administración"
            },
            {
                type: "Contaduría",
                content: "Matemáticas y Economía"
            },
            {
                type: "Mercadotecnia",
                content: "Comunicación y Publicidad"
            },
            {
                type: "Derecho",
                content: "Ética e historia"
            },
            {
                type: "Educación",
                content: "Métodos de investigación y sociología"
            },
            {
                type: "Proyectos",
                content: "Ciencias naturales y Biología"
            },
            {
                type: "Turismo",
                content: "Psicología y cocina"
            },
        ]
    },
    {
        question: "¿Qué libro llama más tu atención?",
        answers: [
            {
                type: "Informática",
                content: "Minería de datos, modelos y algoritmos"
            },
            {
                type: "Administración",
                content: "7 hábitos de personas altamente efectivas"
            },
            {
                type: "Contaduría",
                content: "Finanzas para emprendedores"
            },
            {
                type: "Mercadotecnia",
                content: "Véndele a la mente no a la gente"
            },
            {
                type: "Derecho",
                content: "Los delitos y las penas de Cesare Beccaria"
            },
            {
                type: "Educación",
                content: "Crear hoy la escuela del mañana"
            },
            {
                type: "Proyectos",
                content: "La venganza de la tierra"
            },
            {
                type: "Turismo",
                content: "Exceso de equipaje"
            },
        ]
    },
    {
        question: "Si escogieras un trabajo para el resto de tu vida ¿Cuál sería?",
        answers: [
            {
                type: "Informática",
                content: "Desarrollador web y móvil de una aerolínea"
            },
            {
                type: "Administración",
                content: "Gerente general de una refaccionaria"
            },
            {
                type: "Contaduría",
                content: "Personal del SAT"
            },
            {
                type: "Mercadotecnia",
                content: "Encargado de marketing"
            },
            {
                type: "Derecho",
                content: "Titular de un bufete"
            },
            {
                type: "Educación",
                content: "Profesor de inglés"
            },
            {
                type: "Proyectos",
                content: "Coordinador de desarrollo urbano sustentable de alguna empresa"
            },
            {
                type: "Turismo",
                content: "Gerente general de un hotel"
            },
        ]
    },
    {
        question: "¿Cuál de las siguientes actividades te genera más satisfacción personal?",
        answers: [
            {
                type: "Informática",
                content: "Diseñar redes"
            },
            {
                type: "Administración",
                content: "Analizar y observar problemas que requieren solución"
            },
            {
                type: "Contaduría",
                content: "Asesorar financieramente"
            },
            {
                type: "Mercadotecnia",
                content: "Promover algún producto"
            },
            {
                type: "Derecho",
                content: "Crear una estrategia para la resolución de un problema"
            },
            {
                type: "Educación",
                content: "Buscar estrategias de aprendizaje innovadoras"
            },
            {
                type: "Proyectos",
                content: "No contaminar"
            },
            {
                type: "Turismo",
                content: "Conocer la historia de lugares turísticos "
            },
        ]
    },
    {
        question: "¿Cuál de la siguientes películas es de tu interes?",
        answers: [
            {
                type: "Informática",
                content: "La Red Social"
            },
            {
                type: "Administración",
                content: "El Lobo de wall street"
            },
            {
                type: "Contaduría",
                content: "El Contador"
            },
            {
                type: "Mercadotecnia",
                content: "El diablo viste de Prada "
            },
            {
                type: "Derecho",
                content: "El Crimen perfecto"
            },
            {
                type: "Educación",
                content: "El club de los poetas muertos "
            },
            {
                type: "Proyectos",
                content: "Interestellar"
            },
            {
                type: "Turismo",
                content: "Amor sin Escalas "
            },
        ]
    },
    {
        question: "¿Qué conocimientos deseas adquirir?",
        answers: [
            {
                type: "Informática",
                content: "Evaluar métodos relacionados con la seguridad informática"
            },
            {
                type: "Administración",
                content: "Manejar los recursos humanos de una empresa"
            },
            {
                type: "Contaduría",
                content: "Administrar entradas y gastos de una empresa"
            },
            {
                type: "Mercadotecnia",
                content: "Realizar estudios de mercado"
            },
            {
                type: "Derecho",
                content: "Conocer argumentos Jurídicos para solucionar un conflicto"
            },
            {
                type: "Educación",
                content: "Inspirar y motivar al otro a aprender"
            },
            {
                type: "Proyectos",
                content: "Entender los retos sociales del medio ambiente"
            },
            {
                type: "Turismo",
                content: "Promover actividades Turísticas de un lugar"
            },
        ]
    },
    {
        question: "Si pudieras ser un personaje famoso  ¿Quién serías?",
        answers: [
            {
                type: "Informática",
                content: "Steve Jobs"
            },
            {
                type: "Administración",
                content: "Nicolás Maquiavelo"
            },
            {
                type: "Contaduría",
                content: "Patricia Armendáriz"
            },
            {
                type: "Mercadotecnia",
                content: "Edson Noyola"
            },
            {
                type: "Derecho",
                content: "Mahatma Gandhi"
            },
            {
                type: "Educación",
                content: "Jean Piaget"
            },
            {
                type: "Proyectos",
                content: "Marcus Dantus"
            },
            {
                type: "Turismo",
                content: "Chesky"
            },
        ]
    },
    {
        question: "¿Cuáles de las siguientes cualidades poseo?",
        answers: [
            {
                type: "Informática",
                content: "Habilidad para el trabajo en equipo, capacidad de concentración, capacidad de resolver problemas, Autogestión y Capacidad de adaptarse a los cambios."
            },
            {
                type: "Administración",
                content: "Llevar el control, dirigir, líder, capacidad de prever situaciones inesperada y capacidad de respuesta rápida ante contingencias."
            },
            {
                type: "Contaduría",
                content: "Capacidad para resolver problemas de cálculo, razonamiento abstracto, integridad y disposición."
            },
            {
                type: "Mercadotecnia",
                content: "Buen observador, aliado con la tecnología, adaptabilidad, curioso y capacidad de ventas."
            },
            {
                type: "Derecho",
                content: "Defender tu postura con argumentos, capacidad de negociar, capacidad de convencimiento, buena actitud y capacidad de control emocional."
            },
            {
                type: "Educación",
                content: "Emprendedor, sabe comunicar, colaborador y curioso."
            },
            {
                type: "Proyectos",
                content: "Identificar problemas ambientales, propuestas, soluciones y uso de las tecnologías."
            },
            {
                type: "Turismo",
                content: "Facilidad de expresarse, gusto por la geografía, disponibilidad, búsqueda de información."
            },
        ]
    },
    {
        question: "¿En cuál de los siguientes ambientes te sentirías cómodo para trabajar?",
        answers: [
            {
                type: "Informática",
                content: "Instituciones de sistemas"
            },
            {
                type: "Administración",
                content: "Compañías financieras"
            },
            {
                type: "Contaduría",
                content: "Entidades del sistema financiero"
            },
            {
                type: "Mercadotecnia",
                content: "Empresas (Dirección de Mercadeo)"
            },
            {
                type: "Derecho",
                content: "Organismos de gobierno"
            },
            {
                type: "Educación",
                content: "Instituciones Educativas"
            },
            {
                type: "Proyectos",
                content: "Industrias del medio ambiente"
            },
            {
                type: "Turismo",
                content: "Consultoría y Empresas de Turismo"
            },
        ]
    },
    {
        question: "Si pudieras resolver uno de los siguientes problemas,¿Cuál elegirías?:",
        answers: [
            {
                type: "Informática",
                content: "Actualización del sistema operativo y control de los programas instalados"
            },
            {
                type: "Administración",
                content: "Falta de manuales organizacionales"
            },
            {
                type: "Contaduría",
                content: "Falta de informes financieros"
            },
            {
                type: "Mercadotecnia",
                content: "Problemas de Marketing"
            },
            {
                type: "Derecho",
                content: "Realizar investigaciones y analizar conflictos legales"
            },
            {
                type: "Educación",
                content: "Problemas curriculares"
            },
            {
                type: "Proyectos",
                content: "Conservar la fauna y los ecosistemas"
            },
            {
                type: "Turismo",
                content: "Gestión de proyectos de turismo"
            },
        ]
    },



];


export default quizQuestions;
